import React from "react";
import { useUID } from "react-uid";

export default function Right({ color, size }) {
  const id = useUID();
  const svgSize = size === "sm" ? 12 : 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={svgSize}
      height={svgSize}
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          id={id}
          d="M27.002-6.003c-.26 0-.51-.1-.71-.29l-4.29-4.3v37.59c0 .55-.45 1-1 1s-1-.45-1-1v-37.59l-4.29 4.3c-.39.39-1.03.39-1.42 0-.39-.39-.39-1.03 0-1.42l6-6c.09-.09.2-.16.32-.21.05-.02.09-.04.14-.04.16-.05.34-.05.5 0 .05 0 .09.02.14.04.12.05.23.12.32.21l6 6c.39.39.39 1.03 0 1.42-.2.19-.45.29-.71.29z"
        />
      </defs>
      <use
        fill={color}
        fillRule="evenodd"
        transform="rotate(90 8.002 -1.001)"
        xlinkHref={`#${id}`}
      />
    </svg>
  );
}
